import { z } from "zod";
import { RequiredFirestoreTimestampSchema } from "./common.schema";

/**
 * Policy document schema (without id)
 * Path: organizations/{orgId}/domains/{domainId}/policies/{policyId}
 * Note: Timestamps are converted to Date in the store
 */
export const PolicyDocSchema = z.object({
  // Renamed from `user_id`, which already held the creating member's uid.
  created_by: z.string(),
  updated_by: z.string().nullable().optional(),
  domain_id: z.string(),
  is_enabled: z.boolean(),
  name: z.string(),
  description: z.string(),
  created_at: RequiredFirestoreTimestampSchema,
  updated_at: RequiredFirestoreTimestampSchema.nullable().optional(),
});
export type PolicyDoc = z.infer<typeof PolicyDocSchema>;

/**
 * Policy schema (with id)
 */
export const PolicySchema = PolicyDocSchema.extend({ id: z.string() });
export type Policy = z.infer<typeof PolicySchema>;

/**
 * Parse functions
 */
export const parsePolicy = (data: unknown): Policy => PolicySchema.parse(data);
export const safePolicyParse = (data: unknown) => PolicySchema.safeParse(data);

// UI State type (not a Zod schema - internal app state)
export interface PolicyState {
  policies: Policy[];
  selectedPolicyId: string | null;
  isLoading: boolean;
  error: string | null;
}
